import React from 'react';
import { Pagination as BSPagination } from 'react-bootstrap';
import clsx from 'clsx';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  className?: string;
}

export function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  className = '',
}: PaginationProps) {
  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      onPageChange(page);
    }
  };

  // Show up to 5 page numbers, with ellipsis if needed
  const getPageNumbers = () => {
    const pages = [];
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, currentPage + 2);
    if (currentPage <= 3) {
      end = Math.min(5, totalPages);
    } else if (currentPage >= totalPages - 2) {
      start = Math.max(1, totalPages - 4);
    }
    for (let i = start; i <= end; i += 1) {
      pages.push(i);
    }
    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <BSPagination className={clsx('justify-content-center my-3', className)}>
      <BSPagination.Prev
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
      {pageNumbers[0] > 1 && (
        <>
          <BSPagination.Item
            onClick={() => handlePageChange(1)}
            active={currentPage === 1}
          >
            1
          </BSPagination.Item>
          {pageNumbers[0] > 2 && <BSPagination.Ellipsis disabled />}
        </>
      )}
      {pageNumbers.map((page) => (
        <BSPagination.Item
          key={page}
          active={currentPage === page}
          onClick={() => handlePageChange(page)}
        >
          {page}
        </BSPagination.Item>
      ))}
      {pageNumbers[pageNumbers.length - 1] < totalPages && (
        <>
          {pageNumbers[pageNumbers.length - 1] < totalPages - 1 && (
            <BSPagination.Ellipsis disabled />
          )}
          <BSPagination.Item
            onClick={() => handlePageChange(totalPages)}
            active={currentPage === totalPages}
          >
            {totalPages}
          </BSPagination.Item>
        </>
      )}
      <BSPagination.Next
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
    </BSPagination>
  );
}
